import { z } from 'zod';
export const calendlyConnectionResponseSchema = z.object({
    id: z.string().uuid(),
    status: z.enum(['active', 'needs_reconnect', 'disabled']),
    email: z.string(),
    name: z.string().nullable(),
    ownerMembershipId: z.string().uuid(),
    ownerDisplayName: z.string(),
    lastWebhookError: z.string().nullable(),
    lastEventAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
/** A Calendly Personal Access Token, pasted by the rep rather than obtained
 * through an OAuth consent redirect — see `CalendlyConnectionsService`'s
 * module doc comment for why. */
export const connectCalendlyWithTokenSchema = z.object({
    token: z.string().trim().min(1, 'Paste your Calendly Personal Access Token.'),
});
export const calendlySyncResultSchema = z.object({ synced: z.number(), unmatched: z.number() });
//# sourceMappingURL=connection.js.map